.createOrgModal {
  width: 600px;
  padding: 24px 0;

  .body {
    overflow: hidden;
    display: flex;
    flex-direction: column;

    & > form {
      padding: 0 24px;
      overflow: auto;
      margin-top: 20px;
    }
  }
  
  .wrapper {
    padding: 0 24px;
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
  
  .sectionTitle {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
    row-gap: 0;
  }

  .sectionTitleWithTooltip {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
